import * as exports from '@modals/index';

// All of the Modals should be putted into Modals Array
// Note: don't add the modal components directly in the SharedModule
export const Modals = [
  exports.ModalComponent
];
